// src/pages/app/FeedPage.jsx

import React from 'react';
// CORRECTED PATH: Go up two levels (../../) to reach the src/ root, then down into layouts/
import DashboardLayout from '../../layouts/DashboardLayout'; 
// CORRECTED PATH: Go up two levels (../../) to reach the src/ root, then down into components/
import FeedPostCard from '../../components/FeedPostCard'; 

const FeedPage = () => {

    return (
        <DashboardLayout>
            <h1 className="dashboard-page-title">Community Feed</h1>
            <p className="dashboard-page-subtitle">The full, real-time feed from your local boroughs and topics.</p>
            
            {/* Post Creation Widget */}
            <div className="widget" style={{ marginBottom: '30px' }}>
                <h3 className="widget-title" style={{ borderBottom: 'none' }}>Create a Post</h3>
                <textarea 
                    placeholder="Share a local alert, ask a question, or start a discussion..."
                    style={{ width: '100%', padding: '15px', borderRadius: '8px', border: '1px solid #ccc', minHeight: '100px', boxSizing: 'border-box', marginBottom: '10px' }}
                ></textarea>
                <div style={{ textAlign: 'right' }}>
                    <button className="auth-button auth-primary-button" style={{ width: '150px' }}>Post to Feed</button>
                </div>
            </div>

            {/* Post List - Using the new reusable component */}
            <div className="feed-list-container">
                <FeedPostCard 
                    postId="post1"
                    type="ALERT"
                    title="Suspicious activity near the park tonight"
                    author="VerifiedUser123"
                    date="2 hours ago"
                    initialComments={15}
                    initialUpvotes={42}
                    content="Saw some unhoused people blocking the entrance to the park after 10 PM. Please be cautious if walking alone late. This is a crucial safety alert for everyone in the neighborhood."
                />
                <FeedPostCard 
                    postId="post2"
                    type="DISCUSSION"
                    title="Should we petition for slower speed limits on Broadway?"
                    author="JaneDoe"
                    date="5 hours ago"
                    initialComments={88}
                    initialUpvotes={120}
                    content="Drivers are constantly speeding down the main strip. It's a huge safety risk, especially near the school. Let's discuss petitioning the local board for change."
                />
                <FeedPostCard 
                    postId="post3"
                    type="QUESTION"
                    title="Best plumber in the Upper East Side?"
                    author="NeedsFixing"
                    date="1 day ago"
                    initialComments={6}
                    initialUpvotes={10}
                    content="My kitchen sink backed up this morning. Does anyone have a reliable, non-scamming plumber they can recommend in our area?"
                />
            </div>
        </DashboardLayout>
    );
};

export default FeedPage;